import { Component, Input, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {
  @Input() expanded = true;
  @Input() menuItems: MenuItem[] = [];

  constructor() { 
  }

  ngOnInit(): void {
  }

}
